import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils';

export const getReportCsvUrl = createAsyncThunk('reportCsv/getUrl',
  async ({ type, reportStartDate, reportEndDate, insightType, venueId }: any) => {
    const url = `/v1/reports/download${serializeQueryParam({
      type,
      startDate: reportStartDate,
      endDate: reportEndDate,
      insightType,
      venueId
    })}`
    const response: AxiosResponse<{url: string}> = await instance.get(url)
    return response
  })
